import MainLayout from "@/components/Layout/MainLayout"
import PageVendorReleaseOrder from "@/views/PageVendorReleaseOrder"
import PageVendorReleaseOrderInfo from "@/views/PageVendorReleaseOrderInfo"
import PageSearchVendorReleaseOrder from "@/views/PageSearchVendorReleaseOrder"


export default [
    {
      path: "/VendorReleaseOrder",
      component: MainLayout,
      children: [
        {
          path: "",
          name: "PageVendorReleaseOrder",
          component: PageVendorReleaseOrder,
          props: true,
        },
      ],
    },
    {
      path: "/VendorReleaseOrderInfo",
      component: MainLayout,
      children: [
        {
          path: "",
          name: "PageVendorReleaseOrderInfo",
          component: PageVendorReleaseOrderInfo,
          props: true,
        },
      ],
    },
    {
      path: "/SearchVendorReleaseOrder",
      component: MainLayout,
      children: [
        {
          path: "",
          name: "PageSearchVendorReleaseOrder",
          component: PageSearchVendorReleaseOrder,
          props: true,
        },
      ],
    },

]